var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0151367,
    y: 0.5,
    width: 41.5,
    height: 41.5,
    rx: 8,
    fill: "#F7F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7651 12.1C20.13 12.1 19.6151 12.6149 19.6151 13.25V29.25C19.6151 29.8851 20.13 30.4 20.7651 30.4C21.4003 30.4 21.9151 29.8851 21.9151 29.25V13.25C21.9151 12.6149 21.4003 12.1 20.7651 12.1Z",
    fill: "#6F6C90",
    stroke: "#6F6C90",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7651 20.1C12.13 20.1 11.6151 20.6149 11.6151 21.25C11.6151 21.8851 12.13 22.4 12.7651 22.4H28.7651C29.4003 22.4 29.9151 21.8851 29.9151 21.25C29.9151 20.6149 29.4003 20.1 28.7651 20.1H12.7651Z",
    fill: "#6F6C90",
    stroke: "#6F6C90",
    strokeWidth: 0.3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPlus);
export default __webpack_public_path__ + "static/media/faq-plus.16492e8923ec869a35d5d8d8e9048b62.svg";
export { ForwardRef as ReactComponent };